<template>
  <v-app>
    <div id="app">
      <transition name="slide">
        <component v-bind:is="currentTab"
        v-on:changeTab="currentTab = $event"
        v-bind:firstName="firstName"
        v-bind:lastName="lastName"
        v-bind:email="email"
        v-on:setFirstName="firstName = $event"
        v-on:setLastName="lastName = $event"
        v-on:setEmail="email = $event"
        v-on:exit="currentTab = 'Welcome'"></component>
      </transition>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      firstName: '',
      lastName: '',
      currentTab: 'Welcome',
      tabs: ['Welcome', 'Upload','Stepper']
    }
  }
}
</script>

<style>
  @import "https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css";
  @import "./assets/customcomp.css";
</style>

<style>
body {
  height: 100%;
  /* background: #343a40 !important; */
}
/*
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 15px;
}
*/
.slide-leave-active {
  transition: opacity 1s ease;
  opacity: 0;
  animation: slide-out 1s ease-out forwards;
}

.slide-leave {
  opacity: 1;
  transform: translateX(0);
}

.slide-enter-active {
  animation: slide-in 1s ease-out forwards;
}
/*
@keyframes slide-out {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-30px);
  }
}

@keyframes slide-in {
  0% {
    transform: translateY(-30px);
  }
  100% {
    transform: translateY(0);
  }
}
*/
</style>



// WEBPACK FOOTER //
// src/App.vue